import { render, staticRenderFns } from "./ReceivePurchase.vue?vue&type=template&id=07394bb8&scoped=true"
import script from "./ReceivePurchase.vue?vue&type=script&lang=js"
export * from "./ReceivePurchase.vue?vue&type=script&lang=js"
import style0 from "./ReceivePurchase.vue?vue&type=style&index=0&id=07394bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07394bb8",
  null
  
)

export default component.exports